<template>
    <d-row class="mr-3">
        <a class="btn btn-secondary mr-3" style="color: white;" :href="getLinkForFormat('csv')" target="_blank"><i class="fa">&#xf019;</i><span class="ml-1 d-none d-sm-inline-block">Export</span> (.csv)</a>
        <a class="btn btn-secondary" style="color: white;" :href="getLinkForFormat('xlsx')" target="_blank"><i class="fa">&#xf019;</i><span class="ml-1 d-none d-sm-inline-block">Export</span> (.xlsx)</a>
    </d-row>
</template>

<script>
    import { TransactionService } from '@/main'

    export default {
        props: {
            filter: {
                required: true
            }
        },

        methods: {
            getLinkForFormat(format) {
                return TransactionService.getLinkForExport(this.filter, format)
            },
        }
    }
</script>
